import React from 'react'
import { Controller } from 'react-hook-form'

import { NumericFormat, PatternFormat, NumberFormatBase } from 'react-number-format'
import 'react-phone-input-2/lib/style.css'
import _ from 'lodash'

interface IProps {
  registerField: any
  fieldId: string
  type?: string
  defaultValue?: any
  required?: boolean
  disabled?: boolean
  maskedInput?: any
  control?: any
  validate?: any
  format?: string | (string | RegExp)[] | boolean
  maskChar?: string
  prefix?: string
  suffix?: string
  alwaysShowMask?: boolean
  mask?: string
  thousandsGroupStyle?: string
  thousandSeparator?: boolean
  decimalScale?: number
  value?: string | number | any
  maskType?: string
  allowEmptyFormatting?: boolean
  placeholder?: string
  onChange?: any
}

interface IInputProps {
  field?: any
}

const   InputField = ({
  registerField,
  fieldId,
  type,
  defaultValue,
  required,
  disabled,
  maskedInput,
  control,
  validate,
  format,
  prefix,
  suffix,
  mask,
  thousandsGroupStyle,
  thousandSeparator,
  decimalScale,
  value,
  maskType,
  allowEmptyFormatting,
  placeholder,
  onChange,
}: IProps) => {
  const genericClassname =
    'my-2 h-[42px] w-full rounded border border-gray-300 bg-gray-50 px-3 text-sm leading-5 text-gray-700 focus:text-gray-900 focus:outline-none focus:ring-1 focus:ring-indigo-500 md:mt-1 md:mb-0 md:rounded md:py-2 md:text-sm'

    function formatPhoneNumber(phoneNumberString: string) {
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }
      return phoneNumberString;
    }

    switch (maskedInput) {
    case 'numeric':
      return (
        <Controller
          control={control}
          name={fieldId}
          rules={{
            required: true,
            validate: validate,
          }}
          render={({ field }: IInputProps) => (
            <NumericFormat
              {...field}
              disabled={_.isUndefined(disabled) ? false : disabled}
              value={value ? value : null}
              thousandsGroupStyle={thousandsGroupStyle ? thousandsGroupStyle : ''}
              thousandSeparator={thousandSeparator ? thousandSeparator : false}
              allowNegative={false}
              decimalScale={decimalScale ? decimalScale : null}
              format={format ? format : null}
              prefix={prefix ? prefix : ''}
              suffix={suffix ? suffix : ''}
              mask={mask ? mask : ''}
              className={genericClassname}
              placeholder={placeholder ? placeholder : ''}
              onValueChange={onChange}
              allowLeadingZeros
            />
          )}
        />
      )
    case 'pattern':
      return (
        <Controller
          control={control}
          name={fieldId}
          rules={{
            required: true,
            validate: validate,
          }}
          render={({ field }: IInputProps) => (
            <PatternFormat
              {...field}
              disabled={_.isUndefined(disabled) ? false : disabled}
              value={value ? value : null}
              format={format ? format : null}
              prefix={prefix ? prefix : ''}
              suffix={suffix ? suffix : ''}
              mask={mask ? mask : ''}
              allowEmptyFormatting={allowEmptyFormatting ? allowEmptyFormatting : null}
              className={genericClassname}
              placeholder={placeholder ? placeholder : ''}
              onValueChange={onChange}
              style={{ padding: '12px 8px' }}
            />
          )}
        />
      )
    case 'numeric-pattern':
      return (
        <Controller
          control={control}
          name={fieldId}
          rules={{
            required: true,
            validate: validate,
          }}
          render={({ field }: IInputProps) => (
            <NumberFormatBase
              {...field}
              disabled={_.isUndefined(disabled) ? false : disabled}
              value={value? value : null}
              thousandsGroupStyle={thousandsGroupStyle ? thousandsGroupStyle : ''}
              thousandSeparator={thousandSeparator ? thousandSeparator : false}
              allowNegative={false}
              decimalScale={decimalScale ? decimalScale : null}
              format={format ? formatPhoneNumber : null}
              prefix={prefix ? prefix : ''}
              suffix={suffix ? suffix : ''}
              mask={mask ? mask : ''}
              className={genericClassname}
              placeholder={placeholder ? placeholder : ''}
              onValueChange={(e) => {field.onChange(String(e.floatValue).replace(/[^0-9]/ig, "")); onChange()}}
              allowLeadingZeros
            />
          )}
        />
      )

    default:
      return (
        <input
          type={`${type ? type : 'text'}`}
          {...registerField(`${fieldId}`, {
            required: required,
            validate: validate,
          })}
          disabled={_.isUndefined(disabled) ? false : disabled}
          defaultValue={defaultValue ? defaultValue : ''}
          className={genericClassname}
          placeholder={placeholder ? placeholder : ''}
          onChange={onChange}
        />
      )
  }
}

export default InputField
